import React, { FunctionComponent, useEffect, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Theme, Typography, createStyles, makeStyles } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CloseIcon from '@material-ui/icons/Close'
import { getMedicineNameStage } from '../api/chatApi/chatApi';
import Cookies from 'js-cookie';
import chatApi from '../api/chatApi'

interface Stage {
  routePath: string
  routhPathCode: string
  activeStage: number
  code: string
  legend_id?: number
  testingstage_id: number
}

interface TooltipData {
  testingstage_id: number;
  name: string;
  job_hint: string;
  stage_hint: string;
  stage_hint_name: string;
  stage_hint_blue: string;
}
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    titleWrapper: {
      display: 'flex',
      width: '100% !important',
      justifyContent: 'space-between',
    },
    titleInner: {
      display: 'flex',
      width: '100% !important',
      // justifyContent: 'space-between',
      marginLeft: '8%'
    },
    textTitle: {
      paddingLeft: '20px',
    },
    mainTextContainer: {
      fontFamily: 'Arial',
      backgroundColor: theme.palette.background.paper,
    },
    closeIcon: {
      zIndex: 1,
    },
    '& .MuiButtonBase-root': {
      width: '100% !important',
    }
  })
)

type Props = {
  taskName: string
  taskId: number
  currentStage: Stage
}

const TooltipAccordion: FunctionComponent<Props> = (props: Props) => {
  const classes = useStyles()
  const [tooltipText, setTootipText] = useState<TooltipData | null>(null)
  const [open, setOpen] = useState(true)



  async function getMedicineNameStages() {
    try {
      const result = await getMedicineNameStage({ task_id: props.taskId })

      if (result.data.MedicineNameStage && result.data.MedicineNameStage.length > 0 && props.currentStage) {
        const stageHintElement = result.data.MedicineNameStage.find(el => el.testingstage_id === props.currentStage.testingstage_id)
        setTootipText(stageHintElement)
      }

    } catch (error) {
      console.log(error)
    }
  }


  useEffect(() => {
    if (props.taskId > 0) {
      getMedicineNameStages()
    }
  }, [props.taskId, props.currentStage])

  const getTooltip = async () => {
    if (tooltipText && typeof tooltipText === 'object') {
      return;
    }

    try {
      const res = await chatApi.getHint()
      const hintValue = res.result.filter((el: { key: string; }) =>
        el.key === props.taskName)
      setTootipText(hintValue[0].val)
    } catch (err) {
      console.error(err)
    }
  }


  const cookieName = `tooltip-${props.taskName}`;

  useEffect(() => {
    const savedVisibility = Cookies.get(cookieName);
    if (savedVisibility === `hidden`) {
      setOpen(false);
    }
  }, [cookieName, props.taskName]);

  const handleAccordionClose = () => {
    setOpen(false);
    Cookies.set(cookieName, `hidden`);
  };

  const [windowWidth, setWindowWidth] = useState<number | null>(window.innerWidth)

  useEffect(() => {
    window.addEventListener('resize', () => {
      const resize = () => setWindowWidth(window.innerWidth)
      return () => window.removeEventListener('resize', resize)
    })
  }, [window.innerWidth])

  return (
    open ?
      (<div>
        <Accordion>
          <AccordionSummary
            onClick={getTooltip}
          >
            <div className={classes.titleWrapper}>
              <div className={classes.titleInner}>
                <Typography className={classes.textTitle}>{windowWidth && windowWidth < 800 ? 'Инструкция' : 'Нажмите, чтобы получить инструкцию'}</Typography>
                <ExpandMoreIcon />
              </div>
              <CloseIcon onClick={handleAccordionClose}
                className={classes.closeIcon}
              />
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className={classes.mainTextContainer}>
              {typeof tooltipText === 'string' ? tooltipText : tooltipText?.job_hint || ''}
            </Typography>
          </AccordionDetails>
        </Accordion>
      </div>) : null
  )
}

export default TooltipAccordion;
